module.exports = __webpack_public_path__ + "public/images/header-slide-5.e2c7f8589a05024eca6adff8427bf6f6.jpeg";